import React from 'react';
import Heading from 'ati-ui-react/components/Heading';
import PlainText from 'ati-ui-react/components/PlainText';
import * as styles from './RatingFirmsNotFound.scss';
import strings from '../../strings';

const notFoundImage = '/rating/assets/images/notFound.svg';

const RatingFirmsNotFound = ({ onResetFiltersAction }) => (
  <div className={styles.notFoundContainer}>
    <img src={notFoundImage} width={64} height={64} alt="Not found" />
    <div className={styles.text}>
      <Heading
        className={styles.heading}
        h5
      >
        {strings.notFound}
      </Heading>
      <PlainText
        size="small"
        secondary
        className={styles.changeFilter}
      >
        {strings.clearFilter}
      </PlainText>
    </div>
    <button
      className="glz-button glz-is-small glz-is-primary"
      onClick={onResetFiltersAction}
    >
      {strings.filterButton}
    </button>
  </div>
);

export default RatingFirmsNotFound;
